import { render, staticRenderFns } from "./IncomingTenderListHeader.vue?vue&type=template&id=6264c516&"
import script from "./IncomingTenderListHeader.vue?vue&type=script&lang=js&"
export * from "./IncomingTenderListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports